function initMediaFullWidth() {
  const rootEls = document.querySelectorAll('.media-full-width');
  rootEls.forEach((rootEl) => {
    const video = rootEl.querySelector('video');
    if (!video) return;

    // Fix for autoplay on remote/dash videos.
    // MediaControl.js removes the 'autoplay' attribute in its constructor,
    // which can prevent dash.js from starting automatically.
    const playVideo = () => {
      if (video.mediaControl) {
        video.mediaControl.playIfAble();
      } else {
        const shouldAutoplay = video.autoplay;
        if (shouldAutoplay && video.paused) {
          video.play().catch(() => {});
        }
      }
    };

    // Listen for events that indicate the video is ready to play.
    video.addEventListener('canplay', playVideo);
    video.addEventListener('loadeddata', playVideo);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-media-full-width', () => {
      initMediaFullWidth();
    });
  } else {
    initMediaFullWidth();
  }
});
